import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'motion/react';
import Appearance from 'styles/Appearance.js';
import { useDataStore } from 'files/StateManagement.js';

export const BorderBeam = ({ borderWidth = 2, className, colorTo = "#3CB878", colorFrom = "#239E70", delay = 0, duration = 6, initial, initialOffset = 0, style, transition, useSize = false, whileInView }) => {

    const ref = useRef(null);
    const [size, setSize] = useState({ height: 0, width: 0 });
    const { system } = useDataStore();

    useEffect(() => {
        setSize({
            height: ref.current?.clientHeight || 0,
            width: ref.current?.clientWidth || 0
        });
    }, [ref.current, system.window.size]);

    return (
        <div
        ref={ref}
        className={className}
        style={{
            borderRadius: 'inherit',
            border: `${borderWidth}px solid ${Appearance.colors.divider()}`,
            height: '100%',
            inset: 0,
            maskClip: 'padding-box, border-box',
            maskComposite: 'intersect',
            maskImage: 'linear-gradient(transparent, transparent), linear-gradient(#000, #000)',
            pointerEvents: 'none',
            position: 'absolute',
            WebkitMaskClip: 'padding-box, border-box',
            WebkitMaskComposite: 'source-in',
            WebkitMaskImage: 'linear-gradient(transparent, transparent), linear-gradient(#000, #000)',
            width: '100%',
            ...style
        }}>
            <motion.div
            initial={{ 
                ...initial,
                offsetDistance: `${initialOffset}%`
            }}
            style={{
                aspectRatio: '1/1',
                background: `linear-gradient(90deg, transparent, rgba(255,255,255, 0.5), ${colorFrom}, ${colorTo})`,
                height: size.height / 1.5,
                offsetAnchor: '100% 50%',
                offsetPath: `rect(0 auto auto 0 round 45%)`,
                position: 'absolute',
                width: (useSize ? size.width : size.height) / 1.5
            }}
            transition={{
                delay,
                duration,
                ease: 'linear',
                repeat: Infinity,
                ...transition,
            }} 
            whileInView={{
                ...whileInView,
                offsetDistance: [`${initialOffset}%`, `${100 + initialOffset}%`]
            }} />
        </div>
    )
}

